/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetConfig200ResponseVirtualBrandsInnerDeliveryConfig } from './GetConfig200ResponseVirtualBrandsInnerDeliveryConfig';
import {
    GetConfig200ResponseVirtualBrandsInnerDeliveryConfigFromJSON,
    GetConfig200ResponseVirtualBrandsInnerDeliveryConfigFromJSONTyped,
    GetConfig200ResponseVirtualBrandsInnerDeliveryConfigToJSON,
    GetConfig200ResponseVirtualBrandsInnerDeliveryConfigToJSONTyped,
} from './GetConfig200ResponseVirtualBrandsInnerDeliveryConfig';

/**
 * 
 * @export
 * @interface GetConfig200ResponseVirtualBrandsInner
 */
export interface GetConfig200ResponseVirtualBrandsInner {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseVirtualBrandsInner
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseVirtualBrandsInner
     */
    enabled: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseVirtualBrandsInner
     */
    integrationsEnabled: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseVirtualBrandsInner
     */
    imageId: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseVirtualBrandsInner
     */
    coverImageId: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseVirtualBrandsInner
     */
    virtualBrandId: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseVirtualBrandsInner
     */
    name: string | null;
    /**
     * 
     * @type {GetConfig200ResponseVirtualBrandsInnerDeliveryConfig}
     * @memberof GetConfig200ResponseVirtualBrandsInner
     */
    deliveryConfig?: GetConfig200ResponseVirtualBrandsInnerDeliveryConfig;
}

/**
 * Check if a given object implements the GetConfig200ResponseVirtualBrandsInner interface.
 */
export function instanceOfGetConfig200ResponseVirtualBrandsInner(value: object): value is GetConfig200ResponseVirtualBrandsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('integrationsEnabled' in value) || value['integrationsEnabled'] === undefined) return false;
    if (!('imageId' in value) || value['imageId'] === undefined) return false;
    if (!('coverImageId' in value) || value['coverImageId'] === undefined) return false;
    if (!('virtualBrandId' in value) || value['virtualBrandId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseVirtualBrandsInnerFromJSON(json: any): GetConfig200ResponseVirtualBrandsInner {
    return GetConfig200ResponseVirtualBrandsInnerFromJSONTyped(json, false);
}

export function GetConfig200ResponseVirtualBrandsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseVirtualBrandsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'enabled': json['enabled'],
        'integrationsEnabled': json['integrationsEnabled'],
        'imageId': json['imageId'],
        'coverImageId': json['coverImageId'],
        'virtualBrandId': json['virtualBrandId'],
        'name': json['name'],
        'deliveryConfig': json['deliveryConfig'] == null ? undefined : GetConfig200ResponseVirtualBrandsInnerDeliveryConfigFromJSON(json['deliveryConfig']),
    };
}

export function GetConfig200ResponseVirtualBrandsInnerToJSON(json: any): GetConfig200ResponseVirtualBrandsInner {
    return GetConfig200ResponseVirtualBrandsInnerToJSONTyped(json, false);
}

export function GetConfig200ResponseVirtualBrandsInnerToJSONTyped(value?: GetConfig200ResponseVirtualBrandsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'enabled': value['enabled'],
        'integrationsEnabled': value['integrationsEnabled'],
        'imageId': value['imageId'],
        'coverImageId': value['coverImageId'],
        'virtualBrandId': value['virtualBrandId'],
        'name': value['name'],
        'deliveryConfig': GetConfig200ResponseVirtualBrandsInnerDeliveryConfigToJSON(value['deliveryConfig']),
    };
}

